import React from 'react'

import { SelectItem } from 'types/selectLists'

import { ArticleRow, yearIsValid } from 'hooks/use-articles-check'

import SelectControl from 'components/molecules/SelectControl'
import InputControl from 'components/molecules/InputControl'
import Button from 'components/molecules/Button'
import { Icon, IconType } from 'components/atoms/Icon'

import classes from './style.module.css'

export interface ManualArticlesFormItemProps {
  item: ArticleRow
  onChange: (updated: Partial<ArticleRow>, id: string) => void
  handleRemove: (id: string) => void
  options: Array<SelectItem>
  disabled?: boolean
}

export const ManualArticlesFormItem: React.FC<ManualArticlesFormItemProps> = ({ item, onChange, handleRemove, options, disabled }) => {
  return (
    <div key={item.id} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 24px', gap: 12, alignItems: 'center', marginBottom: 12 }}>
      {Boolean(item.code) === Boolean(item.group) ? (
        <SelectControl
          id={`article-code-${item.id}`}
          value={item.code}
          onChangeHandler={(value: string) => onChange({ code: value }, item.id)}
          options={options}
          placeholder="Выбрать статью..."
          withEmptyValue
          isValid={item.code ? true : undefined}
          disabled={disabled}
        />
      ) : (
        <InputControl id={`article-group-${item.id}`} type="text" value={item.group} onChangeHandler={() => {}} placeholder="Группа" disabled />
      )}

      <InputControl
        id={`article-year-${item.id}`}
        type="number"
        value={item.year}
        onChangeHandler={(inputValue) => onChange({ year: inputValue }, item.id)}
        placeholder="Год"
        isValid={item.year ? yearIsValid(item.year) : undefined}
        disabled={disabled}
      />

      {item.code || item.group ? (
        <Button variant="link" className={classes.removeBtn} onClick={() => handleRemove(item.id)} disabled={disabled}>
          <Icon type={IconType.Close} width="24px" height="24px" />
        </Button>
      ) : null}
    </div>
  )
}
